module.exports = __webpack_public_path__ + "media/images/logo-compact-white-98423bec4b2f82bc979ef6c32eef2ecf.png";